module.exports = __webpack_public_path__ + "media/images/promotions/background-c389255ddc8d730c58f2f87a7231fbba.svg";